import PropTypes from 'prop-types';

export const apiResponsePropType = PropTypes.shape({
  data: PropTypes.any,
  status: PropTypes.number,
  message: PropTypes.string,
  success: PropTypes.bool,
});

export const errorResponsePropType = PropTypes.shape({
  message: PropTypes.string,
  status: PropTypes.number,
  success: PropTypes.bool.isRequired,
});

export const paginatedResponsePropType = PropTypes.shape({
  data: PropTypes.array,
  totalCount: PropTypes.number,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  status: PropTypes.number,
  message: PropTypes.string,
  success: PropTypes.bool,
});
